import { ASSIST_ANCHORS } from './anchors'

/** Copy for the assistant's "show me where" spotlight and its entry chip. */
export const ASSIST_COPY = {
  /** Tip on the Edit toggle while an edit-mode anchor waits behind it. */
  editFirstTip: 'Click Edit first',
  /** Tip on a `parent` (a ⋮ menu trigger, the account menu…) that reveals the anchor. */
  parentFirstTip: 'Open this first',
  /** Miss toast when the anchor isn't in the registry (a newer backend manifest). */
  missUnknown: 'Couldn’t point to it on this page. It may be hidden for your role or tucked in a menu.',
  /** The "Where do I…?" starter chip and what it puts in the composer. */
  whereIsChip: 'Where do I…?',
  whereIsPrefill: 'Where do I ',
}

function stem(word) {
  if (word.endsWith('ies') && word.length > 4) return `${word.slice(0, -3)}y`
  if (word.endsWith('s') && !word.endsWith('ss') && word.length > 3) return word.slice(0, -1)
  return word
}

/**
 * A registry route said out loud, the same way the backend's `ui_find`
 * builds its `route_hint` (`apps/ai_chat/tools/ui_search.py`):
 * `/dashboards/:id` -> `Dashboards > a dashboard`.
 *
 * @param {string} route - `*` or a route pattern
 * @returns {string}
 */
export function routeHint(route) {
  if (route === '*') return 'every page'
  const parts = []
  let previous = ''
  for (const segment of String(route || '').replace(/^\/+|\/+$/g, '').split('/')) {
    if (!segment) continue
    if (segment.startsWith(':')) {
      parts.push(previous ? `a ${stem(previous).replace(/-/g, ' ')}` : 'an item')
    } else {
      const words = segment.replace(/-/g, ' ')
      parts.push(words.charAt(0).toUpperCase() + words.slice(1))
    }
    previous = segment
  }
  return parts.join(' > ') || 'Home'
}

/**
 * The miss toast, "{label} is under {route_hint}" (brief ASSIST-JUDGEMENT-NAV),
 * with the menu that holds it appended for an anchor that has a `parent`.
 *
 * @param {string} anchorId
 * @returns {string}
 */
export function anchorMissMessage(anchorId) {
  const entry = Object.hasOwn(ASSIST_ANCHORS, anchorId) ? ASSIST_ANCHORS[anchorId] : null
  if (!entry) return ASSIST_COPY.missUnknown
  const parent = entry.parent ? ASSIST_ANCHORS[entry.parent] : null
  if (entry.route === '*') {
    return parent ? `${entry.label} is under ${parent.label}` : `${entry.label} is on every page`
  }
  const where = parent ? `${routeHint(entry.route)} > ${parent.label}` : routeHint(entry.route)
  return `${entry.label} is under ${where}`
}
